// File: src/components/common/CardTitle.js
// -----------------------------------------------------
import React from 'react';
import { Typography } from '@mui/material';
import PropTypes from 'prop-types';

/**
 * Content title component with line clamping
 */
const CardTitle = ({ children, lines = 2, ...props }) => (
  <Typography
    variant="h6"
    component="h2"
    gutterBottom
    sx={{
      fontWeight: 'bold',
      fontSize: '1.1rem',
      lineHeight: 1.3,
      mb: 1,
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      display: '-webkit-box',
      WebkitLineClamp: lines,
      WebkitBoxOrient: 'vertical',
      height: `${lines * 1.3}rem`,
      ...props.sx
    }}
    {...props}
  >
    {children}
  </Typography>
);

CardTitle.propTypes = {
  children: PropTypes.node,
  lines: PropTypes.number,
  sx: PropTypes.object
};

export default CardTitle;
